export class Token {
  constructor() { }
  static get() {
    return localStorage.getItem('token')
  }
}
